import React from 'react'
import { connectRange } from 'react-instantsearch-dom'

import 'rheostat/initialize'
import Rheostat from 'rheostat'
import { useTranslation } from 'react-i18next'

import pageLanguage from '../../functions/pageLanguage'

const ltr = pageLanguage() === 'ar'

const RangeSlider = ({
  min,
  max,
  currentRefinement,
  canRefine,
  refine,
  idCustom,
  title,
}) => {
  const [stateMin, setStateMin] = React.useState(min)
  const [stateMax, setStateMax] = React.useState(max)
  const { t } = useTranslation()
  
  React.useEffect(() => {
    if (canRefine) {
      setStateMin(currentRefinement.min)
      setStateMax(currentRefinement.max)
    } else {
    }
  }, [currentRefinement.min, currentRefinement.max])
  if (min === max) {
    return null
  }

  const onChange = ({ values: [min, max] }) => {
    if (currentRefinement.min !== min || currentRefinement.max !== max) {
      refine({ min, max })
    }
  }

  const onValuesUpdated = ({ values: [min, max] }) => {
    setStateMin(min)
    setStateMax(max)
  }

  return (
    <div>
      <div className='range'>
        <span>{stateMin + ' ' + t('SAR') + ' - ' }</span>
        <span>{stateMax + ' ' + t('SAR')}</span>
      </div>
      <div id={title}>
        <Rheostat
          max={max}
          min={min}
          values={[currentRefinement.min, currentRefinement.max]}
          onChange={onChange}
          onValuesUpdated={onValuesUpdated}
        />
      </div>
    </div>
  )
}

const CustomRangeSlider = connectRange(RangeSlider)
export default CustomRangeSlider
